import request from "@/utils/request.js";


/**
 * 删除消息
 * @param {Array} data.idList - 消息ID数组
 */
export function deleteMsg(data) {
	return request.post('msg/deleteMsg', data)
}

/**
 * 消息列表
 * @param {Object} data - 参数
 * @param {Number} data.interactType - 互动类型 1 点赞&收藏 2 新增关注 3 评论与@
 * @param {String} data.title	-消息标题
 * @param {Number} data.type - 消息类型 1活动消息 2系统消息 3互动消息
 * @param {Number} data.page - 页码
 * @param {Number} data.limit - 每页数量
 *  
 */
export function msgList(data) {
	return request.post('msg/list', data)
}

/**
 * 消息设为已读
 * @param {String} msgId - 消息ID
 */
export function setRead(msgId) {
	return request.post(`msg/setRead?msgId=${msgId}`);
}

/**
 * 获取未读消息数量
 */
export function getCntMsg() {
	return request.post(`msg/getCnt`, {}, { noRedirect: true });
}